import { useEffect, useState } from "react";
import { faBold, faItalic, faStrikethrough, faUnderline, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND, LexicalEditor, RangeSelection, TextFormatType } from "lexical";
import ToolbarButton from "../../../components/ToolbarButton";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

export type Definition =
{
    command: typeof FORMAT_TEXT_COMMAND
    textFormatType: TextFormatType
    title: string
    icon: IconDefinition
}

export const Definitions =
{
    bold:          { kind: 'text', command: FORMAT_TEXT_COMMAND, textFormatType: 'bold' as TextFormatType,          title: 'Format Bold',          icon: faBold },
    italic:        { kind: 'text', command: FORMAT_TEXT_COMMAND, textFormatType: 'italic' as TextFormatType,        title: 'Format Italics',       icon: faItalic },
    underline:     { kind: 'text', command: FORMAT_TEXT_COMMAND, textFormatType: 'underline' as TextFormatType,     title: 'Format Underline',     icon: faUnderline },
    strikethrough: { kind: 'text', command: FORMAT_TEXT_COMMAND, textFormatType: 'strikethrough' as TextFormatType, title: 'Format Strikethrough', icon: faStrikethrough },
};

export function TextFormatItem({ definition }: { definition: Definition })
{
    const { title, icon, command, textFormatType } = definition;
    const [editor] = useLexicalComposerContext();
    const [selected, setSelected] = useState(false);
    useEffect(() =>
    {
        return editor.registerUpdateListener(({editorState}) =>
        {
            editorState.read(() =>
            {
                const selection = $getSelection();
                if ($isRangeSelection(selection))
                {
                    setSelected(selection.hasFormat(textFormatType));
                }
            });
        });
    },
    [editor, textFormatType]);
    // const onRangeSelectionChange = (selection: RangeSelection) => setSelected(selection.hasFormat(properties.textFormatType));
    const handleClick = () => editor.dispatchCommand(command, textFormatType);
    return <ToolbarButton title={title} icon={icon} selected={selected} onClick={handleClick} />;
}

export default function TextFormat()
{
    const element =
    <>
        <TextFormatItem definition={Definitions.bold} />
        <TextFormatItem definition={Definitions.italic} />
        <TextFormatItem definition={Definitions.underline} />
        <TextFormatItem definition={Definitions.strikethrough} />
    </>;
    return element;
}